import IconClose from "./close.svg?react";
import IconRight from "./right.svg?react";
import report from "@report";
import { useOpenWindow } from "@utils/window";
import classNames from "classnames";
import { Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface FloatContactContentProps {
  className?: string;
  kalo_pos?: string;
  groupChat: any;
  isFirst?: boolean;
  close?: () => void;
}

export default ({
  className,
  kalo_pos = "float-contact-content",
  groupChat,
  isFirst,
  close,
}: FloatContactContentProps) => {
  const navigate = useNavigate();
  const { openWindow } = useOpenWindow();

  return (
    <div className={classNames("Layout-FloatContactContent", className)}>
      <div className="title">
        <Trans>{groupChat.name}</Trans>
      </div>
      <div className="region">
        <div
          className="region"
          onClick={() => {
            navigate("/contact");
          }}
        >
          <Trans>{"Other Groups"}</Trans>
        </div>
      </div>

      <div className="qrcode" style={{ backgroundImage: `url(${groupChat?.qrcode})` }}></div>
      <div
        className="join"
        onClick={() => {
          openWindow(groupChat.link);
          report.click({ kalo_pos, kalo_value: groupChat.country });
        }}
      >
        <div>
          <Trans>Click to join</Trans>
        </div>
        <IconRight className="icon"></IconRight>
      </div>
      {isFirst && (
        <IconClose
          className="icon-close"
          onClick={() => {
            close && close();
          }}
        ></IconClose>
      )}
    </div>
  );
};
